import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CardSpacer from '../CardSpacer/CardSpacer';
import { getString } from '../../helpers/stringHelpers.js';
import styles from './styles.js';

class AppointmentsSection extends React.Component {
  render() {
    const { classes, appointments } = this.props;

    const stringsComponent = 'appointmentsSection';

    return (
      <div className={classes.root}>
        <Typography variant='h2' component='h1' className={classes.title}>
          {getString(stringsComponent, 'TITLE')}
        </Typography>
        <CardSpacer small={true} />
        {appointments}
      </div>
    );
  }
}

AppointmentsSection.propTypes = {
  classes: PropTypes.object.isRequired,
  appointments: PropTypes.array.isRequired,
};

AppointmentsSection.defaultProps = {};

export default withStyles(styles)(AppointmentsSection);
